<template>
  <div class="sidebar-job-wrapper" id="sidebarJobWrapper">

    <div class="sidebar-job-content" @scroll="scrollFunc">

      <!-- 标题 -->
      <h3 class="title">参考职位</h3>
      <p class="subtitle">根据职位针对性优化简历，通过率更高</p>

      <!-- 搜索 模块 -->
      <div v-if="jobTabScrollActive" class="search-box active" data-growing-container data-growing-idx="501">
        <el-input class="search-input" @change="searchJobList" v-model="searchValue" placeholder="输入目标职位名称"  growing-track="true">
          <i slot="prefix" class="iconfont iconsousuo"></i>
        </el-input>
      </div>
      <div class="search-box" data-growing-container data-growing-idx="501">
        <el-input class="search-input" @change="searchJobList" v-model="searchValue" placeholder="输入目标职位名称" growing-track="true">
          <i slot="prefix" class="iconfont iconsousuo"></i>
        </el-input>
      </div>

      <!-- jobscan 入口 -->
      <div class="jobscan-entry-box" @click="toTestPage()" v-if="!hasJobscanRepor && !isMentorEditor && cvDetail.basic_info.lang === 'cn'" data-growing-container data-growing-idx="502">
        <p class="jobscan-title">你的简历和职位匹配吗？</p>
        <p class="jobscan-content">求职黑科技来帮你：简历和目标职位到底还有哪些差距？针对性优化提升 3 倍通过率！</p>
      </div>

      <!-- jobscan 数据展示 模块 -->
      <div class="jobscan-result-box" v-if="hasJobscanRepor && !isMentorEditor && cvDetail.basic_info.lang === 'cn'" data-growing-container data-growing-idx="503" @click="toJobscanDetail()">
        <div class="jobscan-result-box-header">
          <h6>简历分析报告</h6>
          <div>查看详情<i class="iconfont iconchevron-right"></i></div>
        </div>
        <div class="jobscan-result-box-content">

          <div class="jobscan-result-item">
            <div class="jobscan-result-item-top">
              <span>{{ jobscanResultData.scores.total }}</span><span> /100</span>
            </div>
            <span class="jobscan-result-item-bottom">匹配度总分</span>
          </div>

          <div class="jobscan-result-item">
            <div class="jobscan-result-item-top">
              <span>{{ jobscanResultData.scores.overall }}</span><span> /15</span>
            </div>
            <span class="jobscan-result-item-bottom">简历亮点</span>
          </div>

          <div class="jobscan-result-item">
            <div class="jobscan-result-item-top">
              <span>{{ jobscanResultData.scores.education }}</span><span> /30</span>
            </div>
            <span class="jobscan-result-item-bottom">教育背景</span>
          </div>

          <div class="jobscan-result-item">
            <div class="jobscan-result-item-top">
              <span>{{ jobscanResultData.scores.work }}</span><span> /35</span>
            </div>
            <span class="jobscan-result-item-bottom">工作背景</span>
          </div>

          <div class="jobscan-result-item">
            <div class="jobscan-result-item-top">
              <span>{{ jobscanResultData.scores.abilities }}</span><span> /5</span>
            </div>
            <span class="jobscan-result-item-bottom">胜任力分析</span>
          </div>

          <div class="jobscan-result-item">
            <div class="jobscan-result-item-top">
              <span>{{ jobscanResultData.scores.skills }}</span><span> /15</span>
            </div>
            <span class="jobscan-result-item-bottom">技能分析</span>
          </div>

        </div>
      </div>

      <!-- 职位列表 模块 -->
      <div class="job-list-box" v-if="jobsList && jobsList.length">
        <cvJobCard cardType="jobtab" :cardData="item" v-for="(item, index) in jobsList" :key="index + '&cvJobCard'" data-growing-container :data-growing-idx="505 + index"/>
      </div>

      <div class="no-data" v-else>
        <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
        <p>暂无职位</p>
      </div>

    </div>

    <!-- 查看更多职位 -->
    <div class="more-job-btn" data-growing-container data-growing-idx="504">
      <div @click="toMoreJob()">查看更多职位</div>
    </div>

    <!-- 职位卡片 hover 浮窗 -->
    <cvJobCardDialog v-if="showJobTabCardDialog || showJobTabCardDialogSelf"
                    :cardData="showJobTabCardDialogData"
                    @delivery="deliveryCheck"
                    @createReport="createReport"/>

    <!-- 投递阻断弹窗 -->
    <tipsBlock v-if="showTips"
            tipsTitle="学历与职位不匹配"
            tipsText="学历与职位要求不符，是否要继续投递？"
            confirmButtonText="继续投递"
            cancelButtonText="再看看"
            @confirmFunc="confirmFunc"
            @cancelFunc="cancelFunc"/>

  </div>
</template>
<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import api from '@/api'
	import { routerTo } from '@/assets/js/util'
  import cvJobCard from '../cvJobCard'
  import cvJobCardDialog from '../cvJobCardDialog'
  import tipsBlock from '@/components/alert/tipsBlock'
  import { ioMixin } from '@/assets/js/io'

	export default {
		data () {
			return {
        searchValue: '', // 搜索关键词
        jobsList: [], // 职位列表
        showTips: false
      }
		},
		components: {
      cvJobCard,
      cvJobCardDialog,
      tipsBlock
    },
    mixins: [ioMixin],
		computed: {
			...mapState('editor', [ 'jobTabScrollActive', 'showJobTabCardDialog', 'showJobTabCardDialogSelf', 'showJobTabCardDialogData', 'cvDetail', 'hasJobscanRepor', 'jobscanResultData' ]),

      isMentorEditor () {
        return window.location.href.includes('mentor')
      }
    },
    watch: {},
    created () {
      this.getJobList()
    },
    methods: {
      ...mapActions('editor', ['getReport']),
      ...mapMutations('editor', [ 'setJobTabScrollActive', 'setJobTabCardContentScrollY', 'setIsShowJobscanGuide' ]),

      confirmFunc () {
        this.delivery()
        this.showTips = false
      },
      cancelFunc () {
        this.showTips = false
      },
      // 监听滚动
      scrollFunc (e) {
        let scrollTop = e.target.scrollTop
        this.setJobTabCardContentScrollY(scrollTop)
        if (scrollTop >= 60) {
          this.setJobTabScrollActive(true)
        } else {
          this.setJobTabScrollActive(false)
        }
      },
      // 根据简历推荐职位
      async getJobList () {
        try {
          let params = {
            page: 1,
            size: 10,
            // cv_token: this.$route.params.token,
            resume_token: this.$route.params.token,
            // resume_flag: 1,
            // jd_flag: 1,
            cv_account_token: this.accountToken.c_t || '',
            strong_filter: true
          }
          // let res = await api.cvsV2.cvsDownloadJobsRecommend(params)
          let res = await api.recommend.editorToJob(params)
          if (res.code === 1000) {
            this.jobsList = res.data.jobs
          } else if (res.code === 2000) {
            this.jobsList = []
          } else {
            if(res.code != 201201){
              this.$message.error( res.message || res.msg)
            }
          }
        } catch (e) {
          console.log(e)
        }
      },
      // 搜索职位
      async searchJobList (keyword) {
        if (!keyword) {
          this.getJobList()
          return
        }
        try {
          let params = { from: 0, size: 10, jdflag: 2 ,keyword }
          let res = await api.jobs.companyListUnlogin(params)
          if(res.code === 1000){
            if(res.data.jobs.length === 0){
              this.$message.warning("暂无职位")
            }
            this.jobsList = res.data.jobs
          }else{
            this.$message.error( res.message || res.msg)
          }
        }catch (e) {
          console.log(e)
        }
      },
      // 投递校验
      async deliveryCheck () {

        try {
          let jobToken = this.showJobTabCardDialogData.token
          let cvToken = this.$route.params.token

          // 检查有没有投递过该职位
          let resInfo = await api.recruit.recruitInfosNew(jobToken)
          if (resInfo.code === 1000 && resInfo.data.recruit_info.apply_url.text === '已投递') {
            this.$message.error('你已投递过该职位')
            return
          }

          // 投递校验
          let res = await api.recruit.jobDeliveryVerify(jobToken, { cv_token: cvToken })
          if (res.code === 9005) {
            this.showTips = true
          } else if (res.code === 1000) {
            this.delivery()
          } else {
            this.$message.error(res.message)
          }

        } catch (e) {
          console.log(e)
        }
      },
      // 投递简历
      async delivery () {

        try {
          let url = ''
          let jobToken = this.showJobTabCardDialogData.token
          let cvToken = this.$route.params.token
          if (this.showJobTabCardDialogData.origin_source == 'jd') {
            let params = {token: cvToken, watermark: 'yes'}
            let res = await api.cvsEditor.downloadCv(cvToken, params)
            url = res && res.data.url || ''
          }

          let res = await api.recruit.recommandDeliver(jobToken, {cv_token: cvToken, cv_url: url})
          if (res && res.code == 1000) {
            this.$message.success('投递成功');
          } else {
            this.$message.error('投递失败');
          }
        } catch (e) {
          console.log(e)
        }

      },
      // 创建报告
      async createReport () {
        try {
          let params = {
            cv_token: this.$route.params.token,
            job_token: this.showJobTabCardDialogData.token,
            job_has_been_modified: false,
            job_post: this.showJobTabCardDialogData.job_post,
            company_name: this.showJobTabCardDialogData.company_nick_name || this.showJobTabCardDialogData.company_name,
            job_description: this.showJobTabCardDialogData.jd
          }
          let res = await api.recruit.createReport(params)
          if (res.code === 1000) {
            this.getReport(this.$route.params.token)
            this.$message.success('报告生成成功')
            setTimeout(() => {
              window.open(`/jobscan/results/${res.data.token}.html?form=editor`,'_blank')
            }, 300)
          } else {
            this.$message.error('报告创建失败')
          }

        } catch (e) {
          console.log(e)
        }
      },
      // 去 jobscan 报告详情页
      toJobscanDetail(){
        window.open(`/jobscan/results/${this.jobscanResultData.token}.html?form=editor`,'_blank')
      },
      // 去职位页
      toMoreJob () {
        window.open('/jobs/recommend','_blank')
      },
      // 去 jobscan 页面
      async toTestPage(){
        let res = await api.jobs.checkResume(this.$route.params.token)
        if(res.code === 1000){
          if(!res.data.result){
            this.$message.error(`请先填写 ${res.data.msg} 信息，再尝试～`)
            return
          }
        }else if(res.code === 201201){
          this.$message.error(`请先填写 【姓名】、【学校名称】、【学历】、【专业信息】，再尝试～`)
          return
        }
        this.setIsShowJobscanGuide(false)
        window.open(`/jobscan/index/?token=${this.$route.params.token}&name=${this.cvDetail.basic_info.cv_name}`)
      },
    }
	}
</script>
<style lang="scss" scoped>
  @import './job.scss';
</style>
